"use client";

import React, { Suspense } from "react";
import Image from "next/image";
import AdviceCourseCardSkeleton from "@packages/shared-components/skeleton/advicecoursecardskeleton";
import {
  formatDate,
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { ContentfulInspectorManager } from "@packages/lib/contentful-preview/ContentfulInspector";
import {
  DataLayerGA4AttrType,
  GA4EventAttrType,
} from "@packages/lib/types/datalayerGA";
import Link from "next/link";
import { GAConstants } from "@packages/shared-components/services/constants";
import { usePathname, useRouter } from "next/navigation";
const AdviceCourseCard = ({
  jsondata,
  iscontentPreview,
  index,
  heading,
}: any) => {
  let data = useContentfulLiveUpdates(jsondata);
  if (!iscontentPreview) {
    data = jsondata;
  }
  const path = usePathname();
  const router = useRouter();
  const isSubjectGuidePage = path?.includes("advice/subject-guide");
  function handleGACTABannerCTAclick(articleData: any) {
    const GAlog = async () => {
      const datalog: GA4EventAttrType = {
        event: GAConstants.track_event,
        event_name: "article_click",
        click_text: articleData?.pageTitle || "NA",
        position: String(index + 1),
        field: data?.metaTagTopicsCollection?.items?.[0]?.title,
        cta_url: window.location.origin + articleData?.urlSlug,
      };
      GA4DataLayer(datalog);
    };
    const OldGAlog = async () => {
      const olddatalog: DataLayerGA4AttrType = {
        event: "ga_contentful_events",
        eventName: heading?.toLowerCase()?.includes("scholarship")
          ? "advice_clicks"
          : "article_clicks",
        data_label: data?.metaTagSubTopicsCollection?.items?.[0]?.title,
        data_label3: String(index + 1),
        clearing: localStorage.getItem("clearing") || "in_year",
        page_name: localStorage.getItem("gaPageName")?.toString(),
        article_category: data?.metaTagTopicsCollection?.items?.[0]?.title,
        cta_url: window.location.origin + articleData?.urlSlug,
        contentful_1: heading,
      };
      GA4DataLayerFn(olddatalog);
    };
    OldGAlog();
    GAlog();
  }

  return (
    <>
      {iscontentPreview && (
        <ContentfulInspectorManager
          fields={[
            {
              entryId: data?.sys?.id,
              fieldId: "imgUpload",
              targetSelector: `#advice_carosoul_image${index}${data?.sys?.id}`,
            },
            {
              entryId: data?.sys?.id,
              fieldId: "imgUpload",
              targetSelector: `#advice_carosoul_pod_title${index}${data?.sys?.id}`,
            },
            {
              entryId: data?.sys?.id,
              fieldId: "imgUpload",
              targetSelector: `#advice_carosoul_pod_description${index}${data?.sys?.id}`,
            },
            {
              entryId: data?.sys?.id,
              fieldId: "imgUpload",
              targetSelector: `#advice_carosoul_pod_date${index}${data?.sys?.id}`,
            },
          ]}
        />
      )}
      {data && (
        <Suspense fallback={<AdviceCourseCardSkeleton />}>
          <div
            onClick={() => {
              handleGACTABannerCTAclick(data);
              router.push(data?.urlSlug || "/");
            }}
            className="card h-full flex flex-col bg-white border border-grey-200 hover:border-primary-400 rounded-[8px] shadow-custom-2 overflow-hidden cursor-pointer"
          >
            <div className="card-header">
              {data?.bannerImageCollection?.items[0]?.imgUpload?.url && (
                <Image
                  id={`advice_carosoul_image${index}${data?.sys?.id}`}
                  src={data?.bannerImageCollection?.items[0]?.imgUpload?.url}
                  width={392}
                  height={221}
                  className="block w-full h-auto min-h-[185px]"
                  loading="lazy"
                  alt={data?.bannerImageCollection?.items[0]?.imgAltText}
                />
              )}
            </div>
            <div className="card-body flex flex-col justify-between h-full gap-[10px] p-[16px]">
              {isSubjectGuidePage && (
                <p className="text-x-small font-semibold tracking-[1px] uppercase text-primary-400">
                  subject guide
                </p>
              )}
              <div className="flex flex-col gap-[10px]">
                <Link
                  href={data?.urlSlug || "/"}
                  onClick={(e: any) => e.stopPropagation()}
                  className="no-underline"
                >
                  <h5
                    className="card-title font-semibold text-para-lg text-grey300 line-clamp-2"
                    id={`advice_carosoul_pod_title${index}${data?.sys?.id}`}
                  >
                    {data?.pageTitle}
                  </h5>
                </Link>
                <p
                  className="card-description font-normal small text-grey-700 line-clamp-2"
                  id={`advice_carosoul_pod_description${index}${data?.sys?.id}`}
                >
                  {data?.shortDescription}
                </p>
                {data?.modifiedDate && (
                  <p
                    className="card-date font-normal x-small text-grey300"
                    id={`advice_carosoul_pod_date${index}${data?.sys?.id}`}
                  >
                    {formatDate(data?.modifiedDate)}
                  </p>
                )}
              </div>
            </div>
          </div>
        </Suspense>
      )}
    </>
  );
};

export default AdviceCourseCard;
